module.exports = __webpack_public_path__ + "img/Z60_17.88f5981b.jpg";